<template>
  <home-cards />
</template>

<script>
import HomeCards from './pages/Home/Cards'

export default {
  components: {
    HomeCards
  }
}
</script>
